export const CommodityFormForm = {
  model: 'CommodityForm',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          url: '/main/commodity-forms/',
          label: 'Commodity Form Name',
          title_fields: ['name'],
        },
      },
    },
  ],
}
